import { useEffect, useState } from "react";
import { Assets } from "../../../../assets";
import { CustomButton } from "../../../../common/components/CustomButton/CustomButton";
import { CustomDrawer } from "../../../../common/components/Drawer/CustomDrawer";
import { LFTableV3 } from "../../../../common/components/LFTable/LFTableV3";
import { Loader } from "../../../../common/components/Loader/Loader";
import { ColumnItem } from "../../../../common/models/table";
import { ActivityForm } from "./ActivityForm";
import { useActivityListState, useActivityStore } from "../../store/ActivityStore";
import { ActionsKey } from "../../../../common/models/Actions";
import { ActivityService } from "../../core/_request";
import { HttpStatusCode } from "axios";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { renderAvatarGroup } from "../teamManagement/sales/SalesList";
import { TitleHeader } from "../../../../common/components/TitleHeader/TitleHeader";
dayjs.extend(utc);


const cols: ColumnItem[] = [
  {
    key: "staff",
    title: "Équipe",
    dataIndex: "staff",
    isCanSort: true,
    show: true,
    render: renderAvatarGroup,
  },
  {
    key: "task",
    title: "Tâche",
    dataIndex: "task",
    isCanSort: true,
    show: true,
  },
  {
    key: "startDate",
    title: "Date de début",
    dataIndex: "startDate",
    render: (value: any) =>
      value ? dayjs.utc(value, "DD/MM/YYYY HH:mm:ss").local().format("DD/MM/YYYY") : "-",
    isCanSort: true,
    show: true,
  },
  {
    key: "startTime",
    title: "Heure de début",
    dataIndex: "startDate",
    render: (value: any) =>
      value ? dayjs.utc(value, "DD/MM/YYYY HH:mm:ss").local().format("HH:mm") : "-",
    isCanSort: false,
    show: true,
  },
  {
    key: "endDate",
    title: "Date de fin",
    dataIndex: "endDate",
    render: (value: any) =>
      value ? dayjs.utc(value, "DD/MM/YYYY HH:mm:ss").local().format("DD/MM/YYYY") : "-",
    isCanSort: true,
    show: true,
  },
  {
    key: "endTime",
    title: "Heure de fin",
    dataIndex: "endDate",
    render: (value: any) =>
      value ? dayjs.utc(value, "DD/MM/YYYY HH:mm:ss").local().format("HH:mm") : "-",
    isCanSort: false,
    show: true,
  },
];

function ActivityList() {

  const {
    setActivityList,
    activityList,
    actioned,
    totalItems,
    setActioned,
  } = useActivityStore();
  const { pageState, setPageState, resetPageState } =
    useActivityListState();

  const [isShowForm, setIsShowForm] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
      fetchAllActivities(pageState);
    }, [pageState]);
  
    useEffect(() => {
      if (!isShowForm) {
        setActioned({ action: "no", data: null });
      }
    }, [isShowForm]);
  
    const onActionClick = (item: any, action: ActionsKey) => {

      const id = parseInt(item?.["@id"]?.split("/").pop() || "", 10);

      if (action === "delete") {
        onDeleteHandler(id);
      } else {
        getOne(id, action);
      }
    };
  
    const onShowAddHandler = () => {
      setIsShowForm((prev: boolean) => !prev);
    };
  
    const onClickOnAdd = () => {
      onShowAddHandler();
    };
  
    const getOne = async (id: number, action: any) => {
      try {
        setIsLoading(true);
        const res = await ActivityService.getActivityById(id);
        if (res?.status === HttpStatusCode.Ok) {
          setActioned({
            data: {
              ...res?.data,
            },
            action,
          });
        }
        onShowAddHandler();
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
  
    const onDeleteHandler = async (id: number) => {
      try {
        setIsLoading(true);
        const res = await ActivityService.deleteActivity(id);
        if (res?.status === HttpStatusCode.NoContent) {
          fetchAllActivities();
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
  
    const fetchAllActivities = async (params?: any) => {
      try {
        setIsLoading(true);
        const res = await ActivityService.getAllActivities(params);
        if (res?.status === HttpStatusCode.Ok) {
          setActivityList(res?.data);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
  
    const onFinishAction = () => {
      resetPageState();
      onShowAddHandler();
    };
  
    const handleSetParams = (params: any) => {
      setPageState({
        ...params,
      });
    };
  

  return (
    <>
      <Loader isLoading={isLoading} />
      <div className="mb-4">
        <TitleHeader
            title="Activités journalières"
            isSHowBack
            backUri="/app/operations"
            isEnableAdd
            onClickOnAdd={onClickOnAdd}
          />
      </div>

      <LFTableV3
        columns={cols}
        params={pageState}
        data={activityList}
        onAction={onActionClick}
        isCanDelete={() => true}
        isCanEdit={() => true}
        onSearch={handleSetParams}
        onSort={handleSetParams}
        onResetSearch={resetPageState}
        onChangePage={handleSetParams}
        pagination={{
          defaultCurrentPage: pageState.page,
          itemsPerPage: pageState?.itemsPerPage,
          totalItems: totalItems,
        }}
      />

        {/* Drawer section  */}
        {isShowForm ? (
            <CustomDrawer
            isOpen={isShowForm}
            onClose={onClickOnAdd}
            title={actioned?.action === "update" ? "Modification" : "Nouveau"}
            width={"75%"}
            >
            <ActivityForm
                onFinish={onFinishAction}
                {...(actioned?.action === "update"
                ? {
                    initialValue: actioned?.data,
                    }
                : {})}
            />
            </CustomDrawer>
        ) : (
            ""
        )} 
    </>
  )
}

export default ActivityList